import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getGameById } from "../api/game";
import StartGameFlowLayout from "../components/StartGameFlowLayout";
import { ROUTES } from "../utils/constants";
import { updateStats } from "../utils/helpers";
import reglas2 from "../assets/avatares/reglas-2.mp4";

export default function GameIntroduction() {
	const navigate = useNavigate();
	const game = useSelector((state) => state.game);
	const group = useSelector((state) => state.group);
	const [loading, setLoading] = useState(false);

	const handleNext = () => {
		if (loading) return;
		setLoading(true);
		getGameById(game?._id).then((res) => {
			if (res.status === 200) {
				updateStats({
					...group,
					actualScenario: 1,
					time: 0,
					lastVisited: ROUTES.START_GAME,
				});
				navigate(ROUTES.START_GAME4, {
					state: { activeScenario: 1 },
				});
			} else {
				setLoading(false);
			}
		});
	};

	return (
		<StartGameFlowLayout
			stepKicker="Paso 3 · Reglas (2/3)"
			sidebarTitle="Reglas Dinámica II"
			loading={loading}
			onContinue={handleNext}
			video={reglas2}
		>
			<div className="start-game-rule-block">
				<h3>Sistema de puntos</h3>
				<p>
					<span className="start-game-mark-ok">Respuestas correctas:</span> cada
					acierto suma <strong>10 puntos</strong> al equipo.
					<br />
					<span className="start-game-mark-warn">Respuestas incorrectas:</span>{" "}
					cada error resta <strong>5 puntos</strong>.
					<br />
					<strong>Segundo intento:</strong> en todos los retos se permite volver
					a responder. En ese caso, la respuesta correcta suma{" "}
					<strong>3 puntos</strong>.
				</p>
				<p className="start-game-rule-block-follow">
					<strong>Uso de las pistas:</strong> todas las pruebas incluyen una pista.
					Si utilizan la pista se restan <strong>3 puntos</strong>.
				</p>
				<p className="start-game-rule-block-follow">
					<strong>Consultar especialista:</strong> durante los escenarios podéis
					usar los <strong>3 salvavidas</strong> de la parte superior para
					consultar a un perfil. Cada salvavidas se “gasta” cuando lo usáis.
					Las consultas tienen <strong>coste en puntos</strong> y un número
					limitado de usos.
				</p>
			</div>
			<div className="start-game-rule-block">
				<h3>Tiempo límite</h3>
				<p>Tienen 20 minutos para completar el caso.</p>
			</div>
		</StartGameFlowLayout>
	);
}
